export const enum FormationType {
  Front = 0,
  Rear = 1,
  Orbit = 2,
  Wide = 3,
  Spear = 4,
  Shelter = 5,
}

export const FORMATION_COUNT = 6;
export const FORMATION_NAMES = ['FRONT', 'REAR', 'ORBIT', 'WIDE', 'SPEAR', 'SHELTER'] as const;

export interface FormationStats {
  readonly fireRateScale: number;
  readonly blockRadius: number;
  readonly damageScale: number;
  readonly rechargeScale: number;
}

export const FORMATION_STATS: readonly FormationStats[] = Object.freeze([
  Object.freeze({ fireRateScale: 1, blockRadius: 8, damageScale: 1.08, rechargeScale: 1 }),
  Object.freeze({ fireRateScale: 0.96, blockRadius: 8, damageScale: 1, rechargeScale: 1 }),
  Object.freeze({ fireRateScale: 0.76, blockRadius: 9, damageScale: 0.82, rechargeScale: 1.05 }),
  Object.freeze({ fireRateScale: 0.9, blockRadius: 7, damageScale: 0.92, rechargeScale: 1 }),
  Object.freeze({ fireRateScale: 0.72, blockRadius: 6, damageScale: 1.45, rechargeScale: 0.9 }),
  Object.freeze({ fireRateScale: 0.58, blockRadius: 10, damageScale: 0.72, rechargeScale: 1.35 }),
]);

export function nextFormation(current: FormationType): FormationType {
  return ((current + 1) % FORMATION_COUNT) as FormationType;
}

export function writeFormationTargets(
  formation: FormationType,
  orbitPhase: number,
  outX: Float32Array,
  outY: Float32Array,
): void {
  switch (formation) {
    case FormationType.Front:
      outX[0] = 18; outY[0] = -10;
      outX[1] = 26; outY[1] = 0;
      outX[2] = 18; outY[2] = 10;
      break;
    case FormationType.Rear:
      outX[0] = -18; outY[0] = -10;
      outX[1] = -26; outY[1] = 0;
      outX[2] = -18; outY[2] = 10;
      break;
    case FormationType.Orbit:
      outX[0] = Math.cos(orbitPhase) * 18; outY[0] = Math.sin(orbitPhase) * 18;
      outX[1] = Math.cos(orbitPhase + 2.09439510239) * 18; outY[1] = Math.sin(orbitPhase + 2.09439510239) * 18;
      outX[2] = Math.cos(orbitPhase + 4.18879020479) * 18; outY[2] = Math.sin(orbitPhase + 4.18879020479) * 18;
      break;
    case FormationType.Wide:
      outX[0] = 6; outY[0] = -28;
      outX[1] = 12; outY[1] = 0;
      outX[2] = 6; outY[2] = 28;
      break;
    case FormationType.Spear:
      outX[0] = 18; outY[0] = 0;
      outX[1] = 31; outY[1] = 0;
      outX[2] = 44; outY[2] = 0;
      break;
    case FormationType.Shelter:
      outX[0] = 10; outY[0] = 0;
      outX[1] = -8; outY[1] = -12;
      outX[2] = -8; outY[2] = 12;
      break;
  }
}
